import {
    FETCH_ACTIVE_USER_FULFILLED,
    FETCH_ACTIVE_USER_PENDING,
    FETCH_ACTIVE_USER_REJECTED,
    UPDATE_ACTIVE_USER,
    ProfileAction,
    FETCH_UNREAD_EMAILS_FULFILLED,
    FETCH_UNREAD_EMAILS_REJECTED,
    CLEAR_UNREAD_EMAILS_PENDING
} from './action-types'

import { setMomentLang } from "src/l10n";

export interface IActiveUserProfile extends Spintr.IActiveUser {
    failed: boolean;
    isAdmin: boolean;
    isEditor: boolean;
    isFileUser: boolean;
    isGroupUser: boolean;
    isLoaded: boolean;
    isLoading: boolean;
    mfaEnabled?:    boolean | undefined;
    homeGroupId?: number;
}

export interface IProfileState {
    active: IActiveUserProfile;
    unreadEmails?: number;
    preventEmailFetch: boolean;
    fetchHasBeenInitialized: boolean;
}

const initialState: IProfileState = {
    active: {
        absence: null,
        alternativeInstances: [],
        calendarId: 0,
        created: new Date(),
        crocusKey: null,
        department: null,
        departments: [],
        email: "",
        failed: false,
        feedId: 0,
        galleryId: 0,
        gender: 0,
        googleConnected: false,
        hasPasswordRecovery: false,
        hasSeenAppFeedback: false,
        id: 0,
        images: null,
        initialUser: false,
        instanceId: 0,
        isAdmin: false,
        isEditor: false,
        isFileUser: false,
        isGroupUser: false,
        isLoaded: false,
        isLoading: false,
        isSpintrAdminAccount: false,
        name: "",
        office365Connected: false,
        onboarding: [],
        organisationroles: null,
        rights: null,
        roles: [],
        settings: null,
        state: 0,
        username: "",
        introductionSequences: [],
        lastSeenOperatingInfo: new Date(),
        systemStatusResources: [],
    },
    preventEmailFetch: false,
    fetchHasBeenInitialized: false
};

const profileReducer = (state = initialState, action: ProfileAction) => {
    switch (action.type) {
        case FETCH_ACTIVE_USER_PENDING:
            return {
                ...state,
                active: {
                    ...state.active,
                    failed: false,
                    isLoaded: false,
                    isLoading: true,
                },
                fetchHasBeenInitialized: true,
            };

        case FETCH_ACTIVE_USER_REJECTED:
            return {
                ...state,
                active: {
                    ...state.active,
                    failed: true,
                    isLoaded: true,
                    isLoading: false,
                },
            };

        case FETCH_ACTIVE_USER_FULFILLED:
            const user = action.payload.data;

            const language = parseInt(user.settings.language, 10);
            // TODO: Move this somewhere else - it doesnt belong in the reducer
            setMomentLang(isNaN(language) ? 3 : language);

            return {
                ...state,
                active: {
                    ...state.active,
                    ...user,
                    failed: false,
                    isLoaded: true,
                    isLoading: false,
                    isAdmin: action.payload.data.roles && action.payload.data.roles.includes('administrators'),
                    isEditor: action.payload.data.roles && action.payload.data.roles.includes('editor'),
                    isFileUser: action.payload.data.roles && action.payload.data.roles.includes('fileuser'),
                    isGroupUser: action.payload.data.roles && action.payload.data.roles.includes('groupuser'),
                },
            };
            break;

        case UPDATE_ACTIVE_USER:
            return {
                ...state,
                active: {
                    ...state.active,
                    ...action.meta.user
                }
            }

        case FETCH_UNREAD_EMAILS_FULFILLED:
            return {
                ...state,
                unreadEmails: action.payload.data,
            };

        case FETCH_UNREAD_EMAILS_REJECTED:
            return {
                ...state,
                preventEmailFetch: true,
                unreadEmails: 0,
            };

        case CLEAR_UNREAD_EMAILS_PENDING:
            return {
                ...state,
                unreadEmails: 0,
            };

        default:
            return state;
    }
};

export default profileReducer
